import { Component, inject } from '@angular/core';
import { UserService } from '../../../service/user.service';
import { User } from '../../../classes/user';
import { PricelistService } from '../../../service/pricelist.service';
import { Pricelist } from '../../../classes/pricelist';
import { Logger } from '../../../logging/default-log.service';
import { FilterService } from '../../../service/filter.service';
import { DateService } from '../../../service/date.service';
import { RouterLink } from '@angular/router';
import { SalespersonTelephoneComponent } from '../salesperson.telephone.component';

@Component({
    selector: 'my-pricelists',
    templateUrl: 'pricelists.component.html',
    standalone: true,
    imports: [SalespersonTelephoneComponent, RouterLink]
})
export class PricelistsComponent {
  private userService = inject(UserService);
  private pricelistService = inject(PricelistService);
  private dateService = inject(DateService);
  private filterService = inject(FilterService);
  private logger = inject(Logger);

  public user: User;
  public pricelists: Pricelist[];
  public noPricelistsAvailable: boolean = false;

  constructor() {
    const filterService = this.filterService;

    this.pricelistService
      .getPricelists(filterService.getFilterState().shipmentDate)
      .subscribe(
        pricelists => this.setPricelists(pricelists),
        error => this.logger.error('Failed to get price lists', error)
      );
  }

  getUser(): User {
    return this.userService.getUser();
  }

  /**
   * Gets the number of days between now and the valid until date.
   *
   * @param priceList
   * @returns {number}
   */
  public getAvailableDays(priceList: Pricelist): number {
    return (
      this.dateService.getDaysBetween(new Date(), priceList.validUntil) + 1
    );
  }

  private setPricelists(pricelists) {
    this.pricelists = pricelists;
    this.noPricelistsAvailable = pricelists.length === 0;
  }
}
